import React from 'react';
import clsx from 'clsx';
import { MathUtil } from '../../../../../../common/utils/mathUtil';

const DoubleDragonPatternBarChart = ({ percent, gameName }) => {
  if (Object.keys(percent).length === 0) {
    return null;
  }

  const {
    ball_1_odd_even,
    ball_2_odd_even,
  } = percent;

  return (
    <>
      <div className="data_summary">
        <h3 className="tit">
          1번볼 (빨간색) : <span>패턴 일치 다음회차 분석</span>
        </h3>
        <div className="chart">
          <dl
            className={clsx(
              'bar',
              'ODD',
              parseInt(ball_1_odd_even.odd_cnt) >
                parseInt(ball_1_odd_even.even_cnt) && 'on'
            )}
          >
            <dt>홀</dt>
            <dd>
              <span className="num">{ball_1_odd_even.odd_cnt}</span>
              <span className="per">({ball_1_odd_even.odd_ratio}%)</span>
            </dd>
          </dl>
          <dl
            className={clsx(
              'bar',
              'EVEN',
              parseInt(ball_1_odd_even.odd_cnt) <
                parseInt(ball_1_odd_even.even_cnt) && 'on'
            )}
          >
            <dt>짝</dt>
            <dd>
              <span className="num">{ball_1_odd_even.even_cnt}</span>
              <span className="per">({ball_1_odd_even.even_ratio}%)</span>
            </dd>
          </dl>
        </div>
      </div>
      <div className="data_summary">
        <h3 className="tit">
          2번볼 (노란색) : <span>패턴 일치 다음회차 분석</span>
        </h3>
        <div className="chart">
          <dl
            className={clsx(
              'bar',
              'ODD',
              parseInt(ball_2_odd_even.odd_cnt) >
              parseInt(ball_2_odd_even.even_cnt) && 'on'
            )}
          >
            <dt>홀</dt>
            <dd>
              <span className="num">{ball_2_odd_even.odd_cnt}</span>
              <span className="per">({ball_2_odd_even.odd_ratio}%)</span>
            </dd>
          </dl>
          <dl
            className={clsx(
              'bar',
              'EVEN',
              parseInt(ball_2_odd_even.odd_cnt) <
              parseInt(ball_2_odd_even.even_cnt) && 'on'
            )}
          >
            <dt>짝</dt>
            <dd>
              <span className="num">{ball_2_odd_even.even_cnt}</span>
              <span className="per">({ball_2_odd_even.even_ratio}%)</span>
            </dd>
          </dl>
        </div>
      </div>
    </>
  );
};

export default DoubleDragonPatternBarChart;
